import cx from 'classnames';
import Editor from 'react-simple-code-editor';

import {highlight, languages} from 'prismjs/components/prism-core';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-css';
import 'prismjs/themes/prism.css';
import 'prismjs/themes/prism-coy.css';

type Props = {
    value: string;
    language?: 'html' | 'css';
    className?: string;
    placeholder?: string;
    onChange?: (value: string) => void;
}

export const CodeEditor = ({
    value, language = 'html', placeholder, className, onChange
}: Props) => (
    <Editor
        placeholder={placeholder}
        className={cx('tw-border tw-border-default', className)}
        value={value}
        highlight={(code) => highlight(code, languages[language], language)}
        padding={10}
        style={{
            fontFamily: '"Fira code", "Fira Mono", monospace',
            fontSize: 12,
        }}
        onValueChange={onChange}
    />
);
